import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-back-box",
  "use": "arrow-back-box-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-back-box\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Zm6.873 11.25 4.192-4.192L12 6l-6 6 6 6 1.057-1.058-4.184-4.192H18v-1.5H8.873Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol